export const setCatalogue = (value, page, limit, count) => {
  return {
    type: "SET_CATALOGUE",
    payload: { data: value, page, limit, count },
  };
};
